
















































































import Vue from 'vue'
import FormDialog, { iFormDialogOptions } from '@/components/FormDialog.vue'
import EditorDialog from '@/components/EditorDialog.vue'
export default Vue.extend({
  name: 'post',
  props: ['topics', 'selectedTopics'],
  data() {
    return {
      searchDebounce: null,
      search: '',
      selectedCampaign: '',
      selected: [],
      loadDone: false,
      posts: null,
      postOptions: null,
      contentOptions: null,
      page: 1,
      perPage: 10,
      limits: [10, 20, 50, 100, 200, 500, 1000],
      total: 0
    }
  },
  components: {
    FormDialog,
    EditorDialog
  },
  created() {
    this.reload()
  },
  methods: {
    async reload(local = true) { 
      try {
        this.loadDone = false
        let tasks: any[] = []
        tasks.push(this.$store.dispatch('post/getList', { local, query: { 
          limit: this.perPage,
          filter: this.createFilter(),
          order: { createdAt: -1 },
          page: this.page
        } }).then(res => {
          this.posts = [...res.map((x, i) => ({...x, index: i, 
            category: (x.listTopic as string[]).map(x => {
                let topic = this.topics.find(y => y._id == x)
                if (topic) return topic.name 
                else ''
                }).filter(x => x).join(', ') 
            }))]
        }))
        await Promise.all(tasks)
        this.total = this.$store.getters['post/total']
      } catch (err) {
        this.$store.dispatch('error/handleError', err, 'Lấy danh sách vòng quay thất bại')
      } finally {
        this.loadDone = true
      }
    },
    createFilter() {
      let filter = {}
      if (this.selectedTopics.length) filter['listTopic'] = this.selectedTopics.length?{ $in: this.selectedTopics }:undefined
      if (this.search) filter['title'] = {"$regex": `${this.search}`}
      if (Object.keys(filter).length) return filter
      return undefined
    },
    openPost(item = null) {
        let text = item ? 'Chỉnh sửa bài viết': 'Thêm bài viết mới'  
        this.postOptions = {
          title: text,
          confirmText: text,
          confirmFn: async (data) => {
            if (data) {
              try {
                this.loadDone = false
                let result = item?await this.$store.dispatch('post/update', { id: item._id, data}):await this.$store.dispatch('post/add', data)
                this.$buefy.toast.open({
                  message: item?'Cập nhật bài viêt thành công':'Thêm bài viết thành công',
                  type: 'is-success'
                })
                await this.reload(false)
              } catch (err) {
                this.$store.dispatch('error/handleError', err, 'Thêm bài viết thất bại')
              }
            }
          },
          fields: [
            {
                label: 'Tiêu đề bài đăng',
                property: 'title',
                col: 'is-12',
                type: 'text',
                required: true,
                current: item ? item.title : ''
            }, {
                label: 'Mô tả',
                property: 'description',
                col: 'is-12',
                type: 'textarea',
                required: true,
                current: item ? item.description : ''
            }, {
                label: 'Ảnh bài đăng',
                property: 'thumbnail',
                col: 'is-4',
                type: 'image',
                current: item ? item.thumbnail : ''
            }, {
                label: 'Thể loại',
                property: 'listTopic',
                col: 'is-8',
                type: 'list',
                options: this.topics.map(x => ({ code: x._id, display: x.name })),
                current: item ? item.listTopic : []
            },
          ]
        }
      },
      openContent(item) {
          this.contentOptions = {
              title: item.title,
              content: item.content,
              confirmFn: async (content) => {
                    await this.$store.dispatch('post/update', { id: item._id, data: { content }})
                    this.reload(false)
              }
          }
      },
      async removeSelected() {
        if (!this.selected || !this.selected.length) return
        this.$buefy.dialog.confirm({
          message: 'Bạn có chắc chắn muốn xóa không?',
          onConfirm: async () => {
            try {
              this.loadDone = false
              let tasks: any[] = []
              for (let select of this.selected) {
                tasks.push(await this.$store.dispatch('post/delete', select._id))
              }
              await Promise.all(tasks)              
              this.selected = []
              this.$buefy.toast.open({
                message: 'Xóa thành công',
                type: 'is-success'
              })
              await this.reload(false)
            } catch (err) {
              this.$store.dispatch('error/handleError', err, 'Xóa bài viết thất bại')
            }
          }
        })
      },
      searchChanged() {
        if (this.searchDebounce) clearTimeout(this.searchDebounce)
        this.searchDebounce = setTimeout(() => {
          this.filterChanged()
        }, 300)
      },
      filterChanged() {
        this.page = 1
        this.reload()
      },
      onPageChange(page) {
        this.page = page
        this.reload()
      },
  }
})
